<template>
	<div class="container">
		<div class="hero-grid">
			<!-- 左侧菜单 -->
			<div class="side-menu">
				<!-- 增加空状态提示 -->
				<div v-if="mappedCategories.length === 0" class="empty-menu">
					<i class="fas fa-spinner fa-spin"></i> 菜单加载中...
				</div>
				<div v-else v-for="(cat, idx) in mappedCategories" :key="cat.id" class="menu-item"
					:style="{ '--cat-color': cat.color }">
					<span><i :class="cat.icon" class="menu-icon"></i> {{ cat.name }}</span>
					<i class="fas fa-angle-right" style="font-size:12px;color:#cbd5e1;"></i>

					<!-- 悬浮子菜单 -->
					<div class="submenu-popup" v-if="cat.subs && cat.subs.length > 0">
						<div class="popup-content">
							<div v-for="(sub, sIdx) in cat.subs" :key="sub.id" class="sub-group"
								:style="{ '--delay': sIdx * 0.05 + 's' }">
								<div class="sub-title">
									<i :class="sub.icon || 'fas fa-caret-right'" class="group-icon"></i> {{ sub.name }}
								</div>
								<div class="sub-links">
									<span v-for="(link, lIdx) in sub.links" :key="link.id" class="link-item"
										@click="handleLinkClick(cat, sub, link)">
										{{ link.name }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 中间 Banner -->
			<div class="holo-banner">
				<el-carousel trigger="click" height="500px" arrow="always">
					<el-carousel-item v-for="item in images" :key="item.id"> <!-- 修复key值，避免使用item本身 -->
						<el-image :src="item.imageUrl" class="banner-img" />
					</el-carousel-item>
				</el-carousel>
			</div>

			<!-- 右侧面板 (用户 + 公告) -->
			<div class="right-panel">
				<!-- 用户登录卡片 -->
				<el-card class="user-card" shadow="hover">
					<transition name="fade" mode="out-in">
						<!-- 未登录状态 -->
						<div v-if="!userInfo" key="logged-out">
							<div class="user-avatar">
								<i class="fas fa-user"></i>
							</div>
							<div style="font-weight:bold; margin:10px 0;">Hi, 欢迎来到未来实验室</div>
							<div style="display:flex; gap:10px; justify-content:center;">
								<el-button type="primary" size="small" round @click="handleLogin">登录</el-button>
								<el-button plain size="small" round @click="handleRegister">注册</el-button>
							</div>
						</div>

						<!-- 已登录状态 -->
						<div v-else key="logged-in">
							<!-- <el-avatar class="avatar-hover" :size="60" :src="userInfo.avatar"></el-avatar> -->
							<div class="user-avatar">
								<i class="fas fa-user"></i>
							</div>
							<div style="font-weight:bold; margin:5px 0;">{{ userInfo.customerName }}</div>
							<div style="font-weight:bold; margin:5px 0;">{{ userInfo.name }}</div>
							<div class="user-stats-container">
								<div class="stat-item">
									<div class="stat-label">预存款余额</div>
									<div class="stat-value">￥{{ userInfoValue.customerBalance || '0.00' }}</div>
								</div>
								<div class="stat-divider"></div>
								<div class="stat-item">
									<div class="stat-label">积分</div>
									<div class="stat-value">{{ userInfoValue.integral || '0.00' }}</div>
								</div>
							</div>
							<div style="display:flex; justify-content:center;">
								<el-button type="danger" plain size="small" round @click="handleLogout">退出登录</el-button>
							</div>
						</div>
					</transition>
				</el-card>

				<!-- 公告模块 -->
				<el-card class="notice-card" shadow="hover"
					:body-style="{ padding: '15px', flex: 1, display: 'flex', flexDirection: 'column' }">
					<div class="notice-header">
						<span><i class="fas fa-bullhorn" style="color:var(--tech-blue); margin-right:5px;"></i>
							最新公告</span>
						<el-link type="primary" :underline="false" style="font-size:12px;">更多 <i
								class="fas fa-angle-right"></i></el-link>
					</div>
					<ul class="notice-list">
						<li v-for="notice in notices" :key="notice.id">
							<div class="notice-content">
								<el-tag size="small" effect="plain" v-if="notice.tag"
									:type="getNoticeTagType(notice.tag)"
									style="margin-right:8px; height: 20px; line-height: 18px; border-radius: 4px;">{{
										notice.tag }}</el-tag>
								<span class="notice-title-text">{{ notice.title }}</span>
							</div>
							<span class="notice-date">{{ notice.date }}</span>
						</li>
					</ul>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { ElMessage} from 'element-plus'
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useCategoryStore } from "@/stores/category";
import { storeToRefs } from "pinia";
import { getBanners, getNews, getHot } from "@/apis/api";
import { useCartStore } from "@/stores/cart";
import {
  getUserInfo
} from '@/apis/personal'

// 初始化store
const categoryStore = useCategoryStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();
const cartStore = useCartStore();

// 响应式获取store数据
const { userInfo } = storeToRefs(userStore);
const userInfoValue = ref({})
// 加载个人信息
const loadAddressList = async () => {
  try {
    // const res = await getUserInfo()
    getUserInfo().then(res => {
      if (res.code === 200) {
        userInfoValue.value = res.data
      }
      console.log(res)
    }).catch(err => {
      console.log(err)
    })
  } catch (error) {
    ElMessage.error('获取个人信息失败')
  }
}

const { categoryList } = storeToRefs(categoryStore);

// 计算属性：当前激活菜单
const activeMenu = computed(() => {
	return route.path;
});

// 响应式数据
const images = ref([]);
const newsList = ref([]);
const hotList = ref([]);
const notices = ref([
	{ id: 1, title: '暂无', tag: '重要', date: '2025-12-06' },
]);

// 公告标签类型映射
const getNoticeTagType = (tag) => {
	const map = {
		'重要': 'danger',
		'物流': 'warning',
		'新品': 'success',
		'活动': 'primary',
		'安全': 'info'
	};
	return map[tag] || 'info';
};

// 图标映射表
const iconMap = {
	"精细化学": { icon: "fas fa-flask", color: "#3b82f6" },
	"分析色谱": { icon: "fas fa-chart-area", color: "#8b5cf6" },
	"生命科学": { icon: "fas fa-dna", color: "#10b981" },
	"医药中间体": { icon: "fas fa-pills", color: "#f43f5e" },
	"环境科学": { icon: "fas fa-tree", color: "#22c55e" },
	"分析科学": { icon: "fas fa-microscope", color: "#06b6d4" },
	"高端化学": { icon: "fas fa-gem", color: "#d946ef" },
	"生物科学": { icon: "fas fa-bacteria", color: "#84cc16" },
	"材料科学": { icon: "fas fa-layer-group", color: "#f59e0b" },
	"实验室耗材": { icon: "fas fa-vials", color: "#ef4444" },
	"其他": { icon: "fas fa-th-large", color: "#64748b" },
};

// 关键修复：直接基于categoryList计算，确保响应式
const mappedCategories = computed(() => {
	// 空值保护
	if (!categoryList.value || categoryList.value.length === 0) {
		return [];
	}

	return categoryList.value.map(l1 => {
		const config = iconMap[l1.name] || { icon: 'fas fa-circle', color: '#94a3b8' };

		return {
			name: l1.name,
			icon: config.icon,
			color: config.color,
			id: l1.id,
			subs: (l1.children || []).map(l2 => ({
				name: l2.name,
				id: l2.id,
				icon: 'fas fa-angle-right',
				links: (l2.children || []).map(l3 => ({ id: l3.id, name: l3.name }))
			})).filter(sub => sub.links.length > 0)
		};
	});
});

const getBanner = async () => {
	try {
		const res = await getBanners();
		images.value = res.data || [];
	} catch (error) {
		console.error('获取轮播图失败:', error);
		images.value = [];
	}
};

const getNewsList = async () => {
	try {
		const res = await getNews();
		newsList.value = res.data?.result || [];
	} catch (error) {
		console.error('获取新闻失败:', error);
	}
};

const getHotList = async () => {
	try {
		const res = await getHot();
		hotList.value = res.data?.result || [];
	} catch (error) {
		console.error('获取热门数据失败:', error);
	}
};

// 事件处理函数
const handleLogin = () => {
	router.push({ path: '/login', query: { type: 'login' } });
};

const handleRegister = () => {
	router.push({ path: '/login', query: { type: 'register' } });
};

const handleLinkClick = (...args) => {
	console.log("Clicked link:", ...args);
	categoryStore.setCategoryMenu(args);
	router.push({ path: `/catalogue/${args[args.length - 1].id}` });
};

const handleLogout = () => {
	userStore.logout();
	cartStore.totalNum = 0
};

// 关键修复：调整初始化顺序，确保先加载分类数据
onMounted(async () => {
	// 优先加载分类数据
	try {
		await categoryStore.setCategoryList(); // 等待分类数据加载完成
	} catch (error) {
		console.error('加载分类菜单失败:', error);
	}
	if (userInfo) {
		loadAddressList()
	}

	// 加载其他数据
	getBanner();
	// getNewsList();
	// getHotList();
});

// 额外：监听分类数据变化，确保菜单实时更新
watch(categoryList, (newVal) => {
	console.log('分类数据更新:', newVal);
}, { deep: true });
</script>

<style>
@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateX(-10px);
	}

	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(10px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>

<style scoped>
/* 新增空菜单样式 */
.empty-menu {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	color: #94a3b8;
	font-size: 14px;
}

.hero-grid {
	display: grid;
	grid-template-columns: 240px 1fr 280px;
	gap: 20px;
	min-height: 460px;
	position: relative;
}

/* Side Menu */
.side-menu {
	background: var(--glass-bg);
	backdrop-filter: blur(10px);
	border: var(--glass-border);
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	padding: 10px 0;
	box-shadow: var(--glass-shadow);
	position: relative;
	z-index: 50;
	overflow: visible;
}

.menu-item {
	flex: 1;
	padding: 0 25px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	cursor: pointer;
	transition: all 0.3s ease;
	color: var(--text-main);
	position: relative;
	border-left: 4px solid transparent;
}

.menu-item:hover {
	background: linear-gradient(90deg, rgba(0, 102, 204, 0.05), transparent);
	padding-left: 35px;
	border-left-color: var(--cat-color);
}

.menu-icon {
	width: 24px;
	text-align: center;
	color: #94a3b8;
	transition: color 0.3s;
}

.menu-item:hover .menu-icon {
	color: var(--cat-color);
}

.menu-item:hover {
	color: var(--cat-color);
}

.submenu-popup {
	position: absolute;
	left: 100%;
	top: 0;
	width: 850px;
	min-height: 100%;
	height: auto;
	max-height: 600px;
	background: rgba(255, 255, 255, 0.98);
	backdrop-filter: blur(20px);
	border: 1px solid #e2e8f0;
	border-radius: 0 12px 12px 0;
	box-shadow: 0 15px 30px rgba(0, 102, 204, 0.15);
	padding: 25px;
	z-index: 100;
	display: none;
	overflow-y: auto;
}

.submenu-popup::-webkit-scrollbar {
	width: 6px;
}

.submenu-popup::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.1);
	border-radius: 3px;
}

.submenu-popup::-webkit-scrollbar-track {
	background: transparent;
}

.menu-item:hover .submenu-popup {
	display: block;
	animation: slideIn 0.2s ease-out forwards;
}

.popup-content {
	column-count: 3;
	column-gap: 30px;
}

.sub-group {
	margin-bottom: 25px;
	break-inside: avoid;
	opacity: 0;
	animation: fadeInUp 0.4s ease-out forwards;
}

.sub-title {
	font-weight: 700;
	margin-bottom: 10px;
	border-bottom: 1px solid rgba(0, 102, 204, 0.1);
	padding-bottom: 5px;
	font-size: 14px;
	color: #1e293b;
	display: flex;
	align-items: center;
}

.group-icon {
	color: var(--tech-blue);
	margin-right: 8px;
	font-size: 12px;
}

.sub-links {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.link-item {
	font-size: 13px;
	color: #64748b;
	cursor: pointer;
	padding: 4px 10px;
	background: #f1f5f9;
	border-radius: 6px;
	transition: all 0.25s ease;
}

.link-item:hover {
	background: linear-gradient(135deg, var(--tech-blue), var(--tech-cyan));
	transform: translateY(-2px) scale(1.02);
	box-shadow: 0 4px 10px rgba(0, 102, 204, 0.25);
}

/* Banner */
.holo-banner {
	border-radius: 12px;
	overflow: hidden;
	height: 100%;
	position: relative;
	z-index: 1;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.banner-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.banner-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(to right, rgba(0, 15, 40, 0.85), transparent);
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-left: 50px;
}

.banner-overlay h1 {
	font-size: 36px;
	color: #fff;
	margin: 10px 0;
}

.banner-overlay p {
	color: rgba(255, 255, 255, 0.8);
	margin-bottom: 20px;
}

/* Right Panel */
.right-panel {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 100%;
}

.user-card {
	flex: 0 0 auto;
	text-align: center;
	padding: 20px;
	min-height: 180px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	position: relative;
	overflow: hidden;
}

.user-card::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 4px;
	background: linear-gradient(90deg, var(--tech-blue), var(--tech-cyan));
}

/* 公告样式 */
.notice-card {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.notice-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
	font-weight: bold;
	font-size: 14px;
	border-bottom: 1px solid #f0f0f0;
	padding-bottom: 10px;
}

.notice-list {
	list-style: none;
	padding: 0;
	margin: 0;
	flex: 1;
	overflow-y: auto;
}

.notice-list li {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
	font-size: 13px;
	color: #666;
	cursor: pointer;
	transition: 0.2s;
}

.notice-list li:hover {
	color: var(--tech-blue);
}

.notice-content {
	display: flex;
	align-items: center;
	flex: 1;
	overflow: hidden;
}

.notice-title-text {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 150px;
}

.notice-date {
	font-size: 12px;
	color: #999;
	margin-left: 10px;
	flex-shrink: 0;
}

/* 切换动画 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.user-avatar {
	 width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-size: 24px;
    color: #409eff;
	border: 2px solid #fff;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
	transition: all 0.5s ease;
}

.user-card:hover .user-avatar {
	transform: rotate(360deg) scale(1.1);
	color: var(--tech-blue);
	border-color: var(--tech-blue);
	background: #fff;
	box-shadow: 0 0 15px rgba(59, 130, 246, 0.4);
}

.user-card:hover .avatar-hover {
	transform: rotate(360deg) scale(1.1);
	border-color: var(--tech-blue);
	box-shadow: 0 0 15px rgba(59, 130, 246, 0.4);
}

.avatar-hover {
	transition: all 0.5s ease;
	cursor: pointer;
	border: 2px solid transparent;
}

.avatar-hover:hover {
	transform: rotate(360deg) scale(1.1);
	border-color: var(--tech-blue);
	box-shadow: 0 0 15px rgba(59, 130, 246, 0.4);
}
.user-stats-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f9fa; /* 浅灰色背景，增加层次感 */
    border-radius: 8px;
    padding: 10px 0;
    margin: 10px 0;
}

.stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stat-label {
    font-size: 12px;
    color: #909399; /* ElementUI 辅助文本颜色 */
    margin-bottom: 4px;
}

.stat-value {
    font-size: 16px;
    font-weight: bold;
    color: #303133; /* ElementUI 主要文字颜色 */
}

/* 中间的分割线 */
.stat-divider {
    width: 1px;
    height: 20px;
    background-color: #e4e7ed;
}

@media (max-width: 992px) {
	.hero-grid {
		grid-template-columns: 1fr;
		height: auto;
	}

	.side-menu,
	.right-panel {
		display: none;
	}
}
</style>